function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "p7oaxlu3oa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/directional/left (clip mask)",
    transform: "translate(3 3)",
    style: {
      fill: "none"
    },
    d: "M0 0h18v18H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/directional/left"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/directional/left (clip mask)",
    transform: "rotate(180 8.5 8.5)",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/directional/left",
    transform: "rotate(180 10.5 10.5)",
    style: {
      clipPath: "url(#p7oaxlu3oa)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/directional/left (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/directional/left (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3 1.666V.157a.156.156 0 0 0-.255-.123L.24 6.91a.622.622 0 0 0 0 .982l8.8 6.877a.156.156 0 0 0 .252-.123v-1.51a.316.316 0 0 0-.119-.246L2.147 7.4l7.031-5.49a.316.316 0 0 0 .122-.244z",
    transform: "translate(6.843 4.597)",
    style: {
      fill: "current"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.e1b4e85e632b170e1e717797f98c7fe6.svg";
export { ForwardRef as ReactComponent };